function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleCheck = function SvgCircleCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    style: {
      fill: "#00ccf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3 13.7c-.3 0-.5-.1-.7-.3l-2.8-2.8c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.1 2.1 5.4-5.4c.4-.4 1-.4 1.4 0s.4 1 0 1.4L9 13.4c-.2.2-.4.3-.7.3",
    style: {
      fill: "#f5fbff"
    }
  }));
};
export default SvgCircleCheck;